import React from "react";
import { Tab } from "semantic-ui-react";
import { ListRooms } from "../../../components/Admin/MozillaHubRooms";

export function MozillaHubRooms() {
  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListRooms />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="mozillahub-page">
      <Tab menu={{ secondary: true }} panes={panes} />
    </div>
  );
}
